import Icon from "./Icon";
import { ComponentProps, FunctionComponent, PropsWithChildren } from "react";

import styles from "./IconButton.module.css";
import classNames from "classnames";

type TProps = {
  iconClass?: string;
  onClick: () => void;
  buttonClass?: string;
} & ComponentProps<typeof Icon>;

const IconButton: FunctionComponent<PropsWithChildren<TProps>> = ({
  children,
  onClick,
  iconClass,
  buttonClass,
  ...props
}) => (
  <button onClick={onClick} className={classNames(styles.button, buttonClass)}>
    <Icon {...props} className={iconClass} />
    {children}
  </button>
);

export default IconButton;
